module.exports = __webpack_public_path__ + "static/media/1.b98941e2.jpg";